/**
 * TableForm 工具函数
 * 用于将 FormFieldConfig 转换为 ProColumns 配置，以便在 ProTable 中使用
 */
import type { ProColumns } from '@ant-design/pro-components';
import {
  ProFormDatePicker,
  ProFormDateRangePicker,
  ProFormDigit,
  ProFormSelect,
  ProFormSwitch,
  ProFormText,
  ProFormTextArea,
} from '@ant-design/pro-components';
import type { FormFieldConfig } from './types';

/**
 * 将 FormFieldConfig 转换为 ProColumns 配置
 */
export function convertFormFieldsToColumns(
  fields: FormFieldConfig[],
): ProColumns<any>[] {
  return fields.map((field) => {
    const column: ProColumns<any> = {
      title: field.label,
      dataIndex: field.name,
      hideInTable: true,
      initialValue: field.initialValue,
      formItemProps: {
        rules: field.required
          ? [{ required: true, message: `请输入${field.label}` }]
          : undefined,
        ...field.formItemProps,
      },
    };

    // 根据类型设置 valueType 和 renderFormItem
    switch (field.type) {
      case 'textarea':
        column.valueType = 'textarea';
        break;
      case 'number':
        column.valueType = 'digit';
        break;
      case 'select':
        column.valueType = 'select';
        column.valueEnum = field.options?.reduce(
          (acc, opt) => {
            acc[opt.value] = { text: opt.label };
            return acc;
          },
          {} as Record<string, { text: string }>,
        );
        break;
      case 'date':
        column.valueType = 'date';
        break;
      case 'dateRange':
        column.valueType = 'dateRange';
        break;
      case 'switch':
        column.valueType = 'switch';
        break;
      case 'text':
      default:
        column.valueType = 'text';
        break;
    }

    // 如果有自定义渲染，使用自定义渲染
    if (field.render) {
      column.renderFormItem = () => field.render!();
    }

    return column;
  });
}

/**
 * 获取默认折叠的字段数量
 */
export function getDefaultCollapsedCount(
  fields: FormFieldConfig[],
  defaultCollapsed: number = 3,
): boolean {
  return fields.length > defaultCollapsed;
}

